import { jsx as _jsx } from "react/jsx-runtime";
import { lazy, Suspense } from 'react';
const RichTextEditor = lazy(() => import('./RichTextEditor'));
export default function RichTextEditorLazy(props) {
    return (_jsx(Suspense, { fallback: _jsx("div", { className: "muted pad", children: "Loading rich-text editor\u2026" }), children: _jsx(RichTextEditor, { ...props }) }));
}
